var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex items-center border-b border-black",
      staticStyle: { height: "46px" }
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        staticClass:
          "w-full text-secondary3 leading-tight focus:outline-none py-1",
        attrs: {
          id: _vm.name,
          name: _vm.name,
          type: "text",
          placeholder: _vm.placeholder
        },
        domProps: { value: _vm.value },
        on: { input: _vm.onInput }
      })
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mx-4", staticStyle: { color: "#a1a1a1" } },
      [_c("i", { staticClass: "fas fa-search" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54730dda", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54730dda","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomSearchBar.vue
// module id = null
// module chunks = 